import { render, staticRenderFns } from "./PriceDataColumn.vue?vue&type=template&id=0b522ec0&scoped=true"
import script from "./PriceDataColumn.vue?vue&type=script&lang=js"
export * from "./PriceDataColumn.vue?vue&type=script&lang=js"
import style0 from "./PriceDataColumn.vue?vue&type=style&index=0&id=0b522ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b522ec0",
  null
  
)

export default component.exports